<template>
    <div class="load-bg d-flex justify-content-center align-items-center flex-column text-align-center">
        <FontAwesomeIcon icon="spinner" class="load-icon mb-5" />
        <h1 class="text-white">{{ $store.state.marks.submit_text }}</h1>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
    h1 {
        text-align: center;
    }

    .load-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        user-select: none;
        background-color: rgba(0, 0, 0, .56);
        z-index: 999999999;
    }

    .load-icon {
        color: white;
        font-size: 3rem;
        animation-name: spin;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }

    body, html {
        overflow: hidden;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>